export default function descriptHeight(){
var val_num = $(".params-list__val").length;
var val_count = 0;
var val_height = 0;

	for (var i=1;i<val_num+1;i++){
		if (val_height < 360){
			val_count++;
			val_height += $(".params-list__val").eq(i).height();
		}
	}
	if ($(".params-list__val").eq(val_count).height() < 85 && val_count == val_num){
		val_count++;
	}

if ($(".params-list__val").eq(val_count).height() > 130){
	val_count--;
	}
	if ($(".item__photos").height() > 450){
		valcount = val_num;
	}
$('.params-list').attr("data-show", val_count);
}


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/descriptHeight.js
 **/